"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const event_agent_js_1 = __importDefault(require("@hotmart/event-agent-js"));
class DatahubBulkDrippingService {
    constructor() {
        this.system = constants_1.SYSTEMS.APP_CLUB_ADMIN;
        this.entity = 'dripping';
        this.sendNewBulkEvent = (event) => {
            this.sendEvent('new_bulk', event);
        };
        this.sendNewBulkProcessEvent = (event) => {
            this.sendEvent('new_bulk_process', event);
        };
        this.sendCancelNewBulk = (event) => {
            this.sendEvent('cancel_new_bulk', event);
        };
        this.sendRemoveBulkEvent = (event) => {
            this.sendEvent('remove_bulk', event);
        };
        this.sendRemoveBulkProcess = (event) => {
            this.sendEvent('remove_bulk_process', event);
        };
        this.sendCancelRemoveBulk = (event) => {
            this.sendEvent('cancel_remove_bulk', event);
        };
        this.sendEvent = (action, event) => {
            event_agent_js_1.default.send({
                system: this.system,
                entity: this.entity,
                action,
                event
            });
        };
    }
}
exports.default = new DatahubBulkDrippingService();
